// 海コン受注配車表一覧内の定数

export const 車輌乗務員Bindings = [
  "車番",
  "トレーラー車番",
  "乗務員名",
  "同乗乗務員名",
]

export const 荷主Bindings = ["荷主コード", "荷主略称1", "表紙名"]

export const コンテナ情報Bindings = [
  "荷主依頼番号",
  "コンテナNO",
  "コンテナサイズコード",
  "コンテナ軸コード",
  "コンテナサイズ名称1",
  "コンテナ軸名称1",
]

export const PICKBindings = ["PICK積卸先名称", "PICK積卸先市区町村"]

export const 作業Bindings = ["作業積卸先名称", "作業積卸先市区町村", "作業内容"]

export const 返却Bindings = ["返却積卸先名称", "返却積卸先市区町村"]

export const その他Bindings = ["その他積卸先名称", "その他積卸先市区町村"]

export const 手当情報Bindings = [
  "乗務員売上",
  "食事手当",
  "特別手当",
  "付帯高速料",
  "付帯作業手当",
]
